import React from 'react';  // Add this if not already imported
import Index from "../index";
import Custom from "../custom";

interface ThemeProps {  // Declare a TypeScript interface for ThemeProps
  description?: string;
  theme?: string;
  title?: string;
}

interface StaticPathsReturn {
  paths: { params: { theme: string } }[];
  fallback: boolean | 'blocking';
}

interface StaticPropsReturn {
  props: ThemeProps;
}

// Explicit type annotations for getServerSideProps
// export async function getServerSideProps(context: any): Promise<{ props: {} }> {
//     return {
//         props: {},
//     };
// }

// Explicit type annotations for getStaticPaths
export async function getStaticPaths(): Promise<StaticPathsReturn> {
  return {
      paths: [
          { params: { theme: 'scifi' } },
          { params: { theme: 'erotica' } },
          { params: { theme: 'eroticaCustom' } },
          { params: { theme: 'romance' } },
          { params: { theme: 'got' } }
      ],
      fallback: false,
  };
}

// Explicit type annotations for getStaticProps
export async function getStaticProps(context: { params: { theme: string } }): Promise<StaticPropsReturn> {
  const props: ThemeProps = {};
  const theme = context.params.theme;

  props.theme = theme;

  if (theme in themeDescriptions) {
    props.description = themeDescriptions[theme];
  }
  if (theme in themeTitles) {
    props.title = themeTitles[theme];
  }

  return {
      props: props,
  };
}

// Explicit type annotations for ThemeComponent
const ThemeComponent: React.FC<ThemeProps> = (props: ThemeProps) => {
  const { theme } = props;

  if (theme === 'eroticaCustom') {
    return <Custom {...props} />;
  } else {
    return <Index {...props} />;
  }
};

export default ThemeComponent;

const themeDescriptions: { [key: string]: string } = {
    'erotica': 'Let your imagination run wild...',
    'eroticaCustom': 'Let your imagination run wild...',
};

const themeTitles: { [key: string]: string } = {
    // 'erotica': 'MyTales - Erotic AI story writing',
    // 'eroticaCustom': 'MyTales - Erotic AI story writing',
};
